import React from 'react';

interface IconProps {
  className?: string;
  isActive?: boolean;
}

export const DashboardIcon: React.FC<IconProps> = ({ className = '', isActive = false }) => {
  const gradientId = `dashboardGradient-${Math.random()}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={isActive ? "#FFFFFF" : "#9333EA"} />
          <stop offset="100%" stopColor={isActive ? "#FFFFFF" : "#DB2777"} />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="34" height="34" rx="6" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <rect x="42" y="0" width="34" height="14" rx="4" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <rect x="42" y="22" width="34" height="34" rx="6" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <rect x="0" y="42" width="34" height="14" rx="4" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
    </svg>
  );
};

export const ClientsIcon: React.FC<IconProps> = ({ className = '', isActive = false }) => {
  const gradientId = `clientsGradient-${Math.random()}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={isActive ? "#FFFFFF" : "#9333EA"} />
          <stop offset="100%" stopColor={isActive ? "#FFFFFF" : "#DB2777"} />
        </linearGradient>
      </defs>
      <rect x="8" y="4" width="64" height="56" rx="4" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <line x1="8" y1="4" x2="8" y2="60" stroke={`url(#${gradientId})`} strokeWidth="2.5"/>
      <rect x="72" y="12" width="8" height="8" rx="2" fill={`url(#${gradientId})`}/>
      <rect x="72" y="28" width="8" height="8" rx="2" fill={`url(#${gradientId})`} fillOpacity="0.6"/>
      <rect x="72" y="44" width="8" height="8" rx="2" fill={`url(#${gradientId})`} fillOpacity="0.3"/>
    </svg>
  );
};

export const ProjectsIcon: React.FC<IconProps> = ({ className = '', isActive = false }) => {
  const gradientId = `projectsGradient-${Math.random()}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={isActive ? "#FFFFFF" : "#9333EA"} />
          <stop offset="100%" stopColor={isActive ? "#FFFFFF" : "#DB2777"} />
        </linearGradient>
      </defs>
      <path d="M4 16C4 13.7909 5.79086 12 8 12H24L30 20H72C74.2091 20 76 21.7909 76 24V52C76 54.2091 74.2091 56 72 56H8C5.79086 56 4 54.2091 4 52V16Z" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <path d="M4 16C4 13.7909 5.79086 12 8 12H24C25.1046 12 26 12.8954 26 14V16" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <line x1="16" y1="32" x2="48" y2="32" stroke={`url(#${gradientId})`} strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="16" y1="42" x2="36" y2="42" stroke={`url(#${gradientId})`} strokeWidth="2.5" strokeLinecap="round" strokeOpacity="0.4"/>
    </svg>
  );
};

export const TeamIcon: React.FC<IconProps> = ({ className = '', isActive = false }) => {
  const gradientId = `teamGradient-${Math.random()}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={isActive ? "#FFFFFF" : "#9333EA"} />
          <stop offset="100%" stopColor={isActive ? "#FFFFFF" : "#DB2777"} />
        </linearGradient>
      </defs>
      <circle cx="40" cy="20" r="12" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <path d="M20 56C20 44.9543 28.9543 36 40 36C51.0457 36 60 44.9543 60 56" stroke={`url(#${gradientId})`} strokeWidth="2.5" strokeLinecap="round" fill="none"/>
      <circle cx="14" cy="24" r="9" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" strokeOpacity="0.35"/>
      <path d="M0 52C0 43.1634 7.16344 36 16 36" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" fill="none" strokeOpacity="0.35"/>
      <circle cx="66" cy="24" r="9" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" strokeOpacity="0.35"/>
      <path d="M64 36C72.8366 36 80 43.1634 80 52" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" fill="none" strokeOpacity="0.35"/>
    </svg>
  );
};

export const AdminIcon: React.FC<IconProps> = ({ className = '', isActive = false }) => {
  const gradientId = `adminGradient-${Math.random()}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={isActive ? "#FFFFFF" : "#9333EA"} />
          <stop offset="100%" stopColor={isActive ? "#FFFFFF" : "#DB2777"} />
        </linearGradient>
      </defs>
      <path d="M40 8L48 20H32L40 8Z" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <path d="M40 20V44" stroke={`url(#${gradientId})`} strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="40" cy="48" r="4" fill={`url(#${gradientId})`}/>
      <rect x="12" y="24" width="56" height="32" rx="6" stroke={`url(#${gradientId})`} strokeWidth="2.5" fill="none"/>
      <line x1="24" y1="34" x2="36" y2="34" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeOpacity="0.4"/>
      <line x1="24" y1="42" x2="32" y2="42" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeOpacity="0.4"/>
      <line x1="44" y1="34" x2="56" y2="34" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeOpacity="0.4"/>
      <line x1="44" y1="42" x2="52" y2="42" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeOpacity="0.4"/>
    </svg>
  );
};
